import React from "react";
import { Form, Input } from "antd";
import { BiMap } from "react-icons/bi";

const BusinessAdressState = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item name="state" label="State / Region" rules={[]}>
      <Input
        prefix={<BiMap className="form-item-icon" />}
        placeholder="State / Region"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default BusinessAdressState;
